/* global axios */
import ApiClient from './ApiClient';

class ContactPreChatDataAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId) {
    return axios.get(`${this.url}/${contactId}/pre_chat_data`);
  }

  update(contactId, conversationId, fieldName, value) {
    return axios.patch(
      `${this.url}/${contactId}/pre_chat_data/${conversationId}/${fieldName}`,
      { value }
    );
  }
}

export default new ContactPreChatDataAPI();
